module.exports = __webpack_public_path__ + "public/Icons/languageIcon.svg?59ab801b";